import { Collection } from '../types'

function getArrayFromCollection<T>(collection: Collection<T> | undefined): T[] {
  if (collection === undefined) {
    return []
  }
  return Object.values(collection)
}

export default getArrayFromCollection
